import { useEffect, useRef } from "react";
import { useAuthLite } from "@/context/AuthLite";
import { apiFetch } from "@/lib/api-client";
import i18n from "@/i18n";

const LOCALE_CODES = ["hu", "sk", "en"] as const;

/**
 * When the user logs in (user becomes available), load locale from user preferences
 * so the same language is used on all devices. Renders nothing.
 */
export function LocaleSyncFromUser() {
  const { user } = useAuthLite();
  const lastSyncedUserRef = useRef<string | null>(null);

  useEffect(() => {
    const email = user?.email;
    if (!email) return;
    // Only sync once per user (e.g. after login), not on every navigation
    if (lastSyncedUserRef.current === email) return;
    lastSyncedUserRef.current = email;

    let cancelled = false;
    apiFetch("/api/user/preferences", { credentials: "include", cache: "no-store" })
      .then((res) => res.ok ? res.json() : null)
      .then((data) => {
        if (cancelled || !data?.preferences) return;
        const locale = data.preferences.locale;
        if (locale && LOCALE_CODES.includes(locale)) {
          i18n.changeLanguage(locale);
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [user?.email]);

  return null;
}
